import { useEffect, useState } from "react";
import Modal from "../Modal";
import styles from "./termsModal.module.scss";
import parse from 'html-react-parser';
import { CircularProgress, IconButton } from "@mui/material";
import { useToast } from "../../helpers/hooks";
import CloseIcon from '@mui/icons-material/Close';

interface TermsModalProps {
    open: boolean;
    onClose: () => void;
    getTerms?: () => void;
    getPublicTerms?: () => void;
    terms?: any;
    cleanTerms?: () => void;
    user?: any;
}

const TermsModal = ({
    open,
    onClose,
    getTerms,
    getPublicTerms,
    terms,
    cleanTerms,
    user
}: TermsModalProps) => {
    const toast = useToast();
    const [termsAux, setTermsAux] = useState<string>("");

    useEffect(() => {
        if (open) {
            if (user) {
                getTerms?.();
            } else {
                getPublicTerms?.();
            }
        }
    }, [open, user, getTerms, getPublicTerms]);

    useEffect(() => {
        if (terms?.fetching === "failure") {
            toast("Ha ocurrido un error al mostrar los términos y condiciones");
            cleanTerms?.();
        }
        if (terms?.fetching === "success") {
            if (terms?.data) {
                setTermsAux(terms?.data?.content ?? terms?.data[terms?.data.length - 1]?.content);
            }
            cleanTerms?.();
        }
    }, [terms?.fetching, toast, cleanTerms]);

    return (
        <Modal variant="" open={open} onClose={() => onClose()} className={styles.termsModal}>
            <div className={styles.content}>
                <div className={styles.btnClose}>
                    <IconButton onClick={() => onClose()} size="small" >
                        <CloseIcon />
                    </IconButton>
                </div>

                <div className={styles.container}>
                    {terms?.fetching === "loading" ? (
                        <div className={styles.loaderTerms}>
                            <CircularProgress
                                size={50}
                                thickness={4}
                                classes={{
                                    colorPrimary: styles.loader
                                }}
                            />
                            <p>Cargando términos y condiciones</p>
                        </div>
                    ) : (
                        <div className={styles.termsContainer}>
                            <div className={styles.content}>
                                {parse(termsAux)}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Modal>
    );
};

export default TermsModal;
